/**
 * Flight-log retention/display tuning (`apps/functions/src/fleets.ts`'s
 * `archiveExpiredReports`, and the Fleets page's three log sections).
 * Expired/overflowing records are archived (moved to
 * `universes/{universeId}/reportArchive`), never hard-deleted.
 */
/** `'general'` bucket (and `spyReports`): age-based expiry. */
export const FLIGHT_LOG_GENERAL_RETENTION_DAYS = 3;
/** `'general'` bucket (and `spyReports`): count cap, oldest archived first once exceeded. */
export const FLIGHT_LOG_GENERAL_MAX_COUNT = 100;
/**
 * `'battleReport'` bucket: age-based expiry only, no count cap. Records
 * with `saved: true` are excluded from candidacy entirely (kept
 * indefinitely) — see `selectPrunableIds`'s doc comment in game-engine.
 */
export const FLIGHT_LOG_BATTLE_RETENTION_DAYS = 30;
/** Card-grid page size — up to 9 columns × 3 rows at the widest breakpoint. */
export const FLIGHT_LOG_PAGE_SIZE = 27;
/**
 * How many battle reports a player may `saved: true` at once, exempting
 * them from the 30-day expiry. Same `Record<PremiumTier, number>` + getter
 * shape as `constants/queue.ts`'s queue limits.
 */
export const SAVED_BATTLE_REPORT_LIMITS = {
    normal: 5,
    premium: 10,
    platinum: 20,
};
export function getSavedBattleReportLimit(tier) {
    return SAVED_BATTLE_REPORT_LIMITS[tier ?? "normal"];
}
//# sourceMappingURL=flightLogs.js.map